import { defineComponent as _defineComponent } from 'vue'
import { reactive, computed, ref } from "vue";
  import useVuelidate from "@vuelidate/core";
  import { numeric, required } from "@vuelidate/validators";
  import store from "@/store";
  import router from "@/router";
  import { CreateEstateMapInterface } from "@/types/CreateEstateMapInterface";
  import { isPngType, isValidFileSize } from "@/helpers/fileUpload";
  import { useToast } from "vue-toastification";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminEstateMapCreate',
  setup(__props, { expose: __expose }) {
  __expose();

  const userId = router.currentRoute.value.params.userId;
  const estateId = router.currentRoute.value.params.estateId;
  const form = reactive({
    width: 0,
    height: 0,
    file: null,
  });
  const rules = computed(() => {
    return {
      width: { required, numeric, $autoDirty: true },
      height: { required, numeric, $autoDirty: true },
      file: { required },
    };
  });
  const v$ = useVuelidate(rules, form);
  const loading = ref(false);
  const toast = useToast();

  function selectFile(e: any) {
    if (!e.target.files.length) {
      return;
    }

    const selectedFile = e.target.files[0];

    if (!isPngType(selectedFile) || !isValidFileSize(selectedFile)) {
      return;
    }

    form.file = selectedFile;
  }
  function uploadFile() {
    const data = new FormData();

    data.append("file", form.file as File);
    const payload = {
      landownerId: userId,
      estateId,
      data,
    };

    return store.dispatch("estate/uploadEstateMapImg", payload);
  }
  async function createMap() {
    v$.value.$touch();
    const isFormCorrect = await v$.value.$validate();

    if (!isFormCorrect) return;

    loading.value = true;
    uploadFile()
      .then((res) => {
        const data: CreateEstateMapInterface = {
          landownerId: userId as string,
          estateId: estateId as string,
          mapImage: res.data,
          size: {
            width: form.width,
            height: form.height,
          },
        };

        store
          .dispatch("estate/createEstateMap", data)
          .then(() => {
            router.push({
              name: "AdminEstateMap",
              params: { userId, estateId },
            });
          })
          .catch(() => {
            loading.value = false;
            toast.error("Something went wrong");
          });
      })
      .catch(() => {
        loading.value = false;
        toast.error("Something went wrong");
      });
  }

const __returned__ = { userId, estateId, form, rules, v$, loading, toast, selectFile, uploadFile, createMap, reactive, computed, ref, get useVuelidate() { return useVuelidate }, get numeric() { return numeric }, get required() { return required }, get store() { return store }, get router() { return router }, get CreateEstateMapInterface() { return CreateEstateMapInterface }, get isPngType() { return isPngType }, get isValidFileSize() { return isValidFileSize }, get useToast() { return useToast } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})